import { shape } from 'prop-types'

export default propTypes =>
  ({
    match: shape({
      params: shape(propTypes).isRequired
    }).isRequired
  })
